import React from "react";
import Seo from "../components/Seo";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { useTranslation } from "react-i18next";
import { ShieldCheck, Heart, Users } from "lucide-react";

export default function About() {
  const { t } = useTranslation();
  return (
    <><Seo title="About Us" description="Learn about Universal Tree — a trusted marketplace connecting customers with verified home service professionals across India." />
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="max-w-5xl mx-auto px-6 lg:px-12 py-8 md:py-20 flex-1">
        <p className="text-xs uppercase tracking-[0.25em] text-[#D9734E] font-bold">{t("about.ourStory")}</p>
        <h1 className="font-display text-5xl lg:text-6xl font-light tracking-tight mt-3 leading-[1.05]">
          {t("about.hero.title")}
        </h1>
        <p className="mt-8 text-lg text-[#646964] leading-relaxed max-w-2xl">
          {t("about.hero.description")}
        </p>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-6">
          {[
            { i: <ShieldCheck size={28} strokeWidth={1.5}/>, t: t("about.feature.verified.title"), d: t("about.feature.verified.description") },
            { i: <Heart size={28} strokeWidth={1.5}/>, t: t("about.feature.fair.title"), d: t("about.feature.fair.description") },
            { i: <Users size={28} strokeWidth={1.5}/>, t: t("about.feature.built.title"), d: t("about.feature.built.description") },
          ].map((c, i) => (
            <div key={i} className="bg-white border border-[#E2E0D9] p-8 rounded-sm">
              <div className="text-[#1C4532]">{c.i}</div>
              <p className="font-display text-2xl mt-5">{c.t}</p>
              <p className="text-sm text-[#646964] mt-3 leading-relaxed">{c.d}</p>
            </div>
          ))}
        </div>
      </main>
      <Footer />
    </div>
    </>
  );
}
